import {Injectable} from '@angular/core';

import {ModalService} from '../../../services/modal/modal.service';
import {TranslateService} from '../../../utilities/translate/translate.service';
import {ProjectSubmodule} from '../../../resources/submodule/project-submodule.interface';

import {ProjectElementStore} from '../project-element/project-element-store';
import {ProjectSubmoduleStore} from './project-submodule-store';
import {empty, EMPTY} from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProjectSubmoduleService {

  public state$;

  constructor(
    private modalService: ModalService,
    private projectSubmoduleStore: ProjectSubmoduleStore,
    private projectElementStore: ProjectElementStore,
    private translateService: TranslateService
  ) {
    this.state$ = this.projectSubmoduleStore.state$;
  }

  /**
   * Shows a confirmation modal and then set the matching element to .active = false.
   *
   * @param id Element to delete.
   */
  delete(id: ProjectSubmodule['_id']): void {

    const elements = this.projectElementStore.getByRelated('submodule', id);
    let content = this.translateService.get('module') + ' ' + this.translateService.get('contains').toLowerCase()
      + ' ' + elements.length + ' ';
    if (elements.length === 1) {
      content += this.translateService.get('specification').toLowerCase();
    } else {
      content += this.translateService.getPlural('specification').toLowerCase();
    }
    content += '<br>' + this.translateService.get('areyousuredeletesubmodule');

    this.modalService.confirm({
      title: this.translateService.get('deletespecificationtitle'),
      content: content,
      action: this.translateService.getPlural('delete'),
      actionIcon: 'delete',
      type: 'warn'
    }).afterClosed().subscribe((click: any) => {
      if (click === this.translateService.getPlural('delete')) {
        this.projectElementStore.getByRelated('submodule', id).map(projectElement => projectElement.active = false);
        this.projectSubmoduleStore.delete(id);
      }
    });
  }

  /**
   * Given an element it shows the rename modal and propagates a rename action.
   *
   * @rutger Iets aangepast vanwege:
   *  - Werkt net als `this.delete()` enkel met id, haal item op om te voorkomen dat je met referentie werkt.
   *  - Als je direct `name` opgeeft, wordt de modal geskipt, handig voor bijv inline edits.
   *
   * @param id Element id.
   * @param [name] Optional name. When not given, a rename modal prompt is triggered.
   */
  rename(id: ProjectSubmodule['_id'], name?: ProjectSubmodule['name']): void {
    const element = this.projectSubmoduleStore.get(id);
    if (!name) {
      this.modalService.prompt(
        this.translateService.get('rename'),
        element.name
      ).afterClosed().subscribe((response: any) => {
        if (response !== null) {
          this.projectSubmoduleStore.update({_id: element._id, name: response});
        }
      });
    } else {
      this.projectSubmoduleStore.update({_id: element._id, name: name});
    }
  }

  /**
   * Start new submodule creation dialog
   * need paramters for submodule: projectId, versionId, moduleId
   * @param submodule .
   */
  create(submodule) {
    return this.modalService.prompt(this.translateService.get('addsubmodule'), this.translateService.get('submodulename'))
      .afterClosed().pipe(switchMap(response => {
      if (response) {
        submodule.name = response;
        return this.projectSubmoduleStore.insert(submodule);
      }

      return EMPTY;
    }));
  }

  refresh() {
    this.projectSubmoduleStore.refresh();
  }
}
